import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { AnimateIn } from "@/hooks/useAnimations";

const faqs = [
  { q: "How long does it take to build a website?", a: "Most websites are delivered within 7-14 days depending on complexity. Simple business websites can be ready in as little as 5 days, while larger projects with custom features may take 3-4 weeks." },
  { q: "What is the cost of a website?", a: "Our base charge starts from Rs 15,000 for a professional business website. Final cost depends on features, pages, and complexity. Our AI wizard generates a custom proposal with 4-5 tiered packages tailored to your business in minutes. Contact us for a free custom quote." },
  { q: "What is a domain and hosting?", a: "A domain is your website's address on the internet (like kokosites.in or yourbusiness.com). It costs around Rs 500-1,500 per year depending on the extension (.com, .in, .co.in). Hosting is the server space where your website files are stored so people can access them online. Hosting costs Rs 1,500-5,000 per year depending on traffic and storage needs. We help you set up both as part of our service." },
  { q: "Do you provide website hosting and domain?", a: "Yes! We help you set up hosting and domain registration. We recommend reliable Indian hosting providers for the best speed and uptime for Indian audiences. Domain and hosting costs are separate from website development charges." },
  { q: "Will my website work on mobile phones?", a: "Absolutely. Every website we build is fully responsive and mobile-first. With over 70% of Indian internet users on mobile, we ensure your site looks perfect on every screen size." },
  { q: "Can I update the website content myself?", a: "Yes, we can integrate a simple content management system (CMS) so you can update text, images, and other content without any technical knowledge." },
  { q: "Do you offer SEO services?", a: "Every website comes with basic on-page SEO optimization. We also offer advanced SEO packages including Google My Business setup, local SEO, and content strategy for better search rankings." },
  { q: "What if I need changes after the website is live?", a: "We offer free minor revisions for the first month after launch. For ongoing support and updates, we have affordable monthly maintenance plans ranging from INR 500 to INR 2,000/month depending on the complexity and frequency of changes required." },
  { q: "Do you work with clients outside India?", a: "While we primarily serve Indian businesses, we're happy to work with clients worldwide. Our communication and delivery process is fully digital, making remote collaboration seamless." },
];

export default function FAQSection() {
  return (
    <section id="faq" data-testid="faq-section" className="py-14 sm:py-20 lg:py-24 bg-[#141414] scroll-mt-20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <AnimateIn>
          <div className="text-center mb-16">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-red-600 mb-4">Got Questions?</p>
            <h2 className="text-3xl sm:text-4xl font-black uppercase tracking-tight">
              Frequently <span className="text-red-600">Asked</span>
            </h2>
          </div>
        </AnimateIn>

        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AnimateIn key={i} delay={0.12 * i}>
              <AccordionItem
              key={i}
              value={`faq-${i}`}
              data-testid={`faq-item-${i}`}
              className="border border-white/10 bg-[#0A0A0A] px-6 hover:border-red-600/60 transition-all duration-300 rounded-none hover:-translate-y-0.5 hover:shadow-[4px_4px_0_0_rgba(229,9,20,0.7)]"
            >
              <AccordionTrigger className="text-sm font-bold text-white hover:text-red-500 uppercase tracking-wide text-left py-5 [&[data-state=open]]:text-red-500 transition-colors">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-zinc-400 leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
            </AnimateIn>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
